import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";


function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");



  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (!res.ok) {
        setMessage(`❌ ${data.error || data.message || "Failed to send email"}`);
      } else {
        setMessage("✅ Password reset link sent! Redirecting to login...");
        setTimeout(() => navigate("/login"), 2000);
      }
    } catch (err) {
      console.error("❌ Forgot password error:", err);
      setMessage("❌ Network error. Check your connection.");
    }
  };

  return (
    <div style={containerStyle}>
      <h2 style={headerTitle}>Forgot Password</h2>
      {message && (
        <p
          style={{
            textAlign: "center",
            color: message.includes("❌") ? "#d32f2f" : "#2e7d32",
            fontWeight: 600,
          }}
        >
          {message}
        </p>
      )}
      <form onSubmit={handleSubmit} style={formStyle}>
        <label style={boldLabel}>Email Address</label>
        <input
          type="email"
          required
          placeholder="Enter your account email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
        />
        <button type="submit" style={buttonStyle}>
          Send Reset Link
        </button>
      </form>
    </div>
  );
}

// ===== Styles =====
const containerStyle = {
  maxWidth: "400px",
  margin: "60px auto",
  background: "#fff",
  padding: "25px",
  borderRadius: "10px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
};
const headerTitle = {
  textAlign: "center",
  marginBottom: "20px",
  color: "#2e7d32",
};
const formStyle = { display: "flex", flexDirection: "column", gap: "15px" };
const boldLabel = { fontWeight: "bold" };
const inputStyle = {
  padding: "12px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "1rem",
};
const buttonStyle = {
  background: "#4caf50",
  color: "#fff",
  padding: "12px",
  border: "none",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer",
};

export default ForgotPassword;
